import { render, staticRenderFns } from "./WhatYouGet.vue?vue&type=template&id=61fbe85b&scoped=true&"
import script from "./WhatYouGet.vue?vue&type=script&lang=js&"
export * from "./WhatYouGet.vue?vue&type=script&lang=js&"
import style0 from "./WhatYouGet.vue?vue&type=style&index=0&id=61fbe85b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fbe85b",
  null
  
)

export default component.exports